import { delay } from 'redux-saga';
import { select, takeEvery, call, apply } from 'redux-saga/effects';

import { getVisitor } from '../selectors/conversation';
import { RedirectToUrlAction, SendExternalEventAction } from '../typedefs/actions';
import * as actionTypes from '../typedefs/actionTypes';
import { VisitorState } from '../typedefs/store';
import { instance as LocalStorageManager } from '../util/LocalStorageManager';
import { sendDomEvent } from '../util/index';

/**
 * Dispatch custom events to the owning webpage
 */
function* sendExternalEvent(action: SendExternalEventAction) {
    yield call(sendDomEvent, action.payload.detail, action.payload.name);
}

function* redirectToUrl(action: RedirectToUrlAction) {
    yield call(delay, action.payload.delay * 1000);
    yield call(window.open, action.payload.url, '_self');
}

/**
 * Save contact info in local storage as it is gathered by Watson
 */
function* contactInfoGathered() {
    const visitor: VisitorState = yield select(getVisitor);
    yield apply(LocalStorageManager, LocalStorageManager.addSharedData, [
        {
            contactInfo: visitor.contactInfo,
        },
    ]);
    yield call(sendDomEvent, { action: 'contact_info_gathered', contactInfo: visitor.contactInfo });
}

export default function* conversationSaga() {
    yield takeEvery(actionTypes.SOCKET_EVENT_SEND_EXTERNAL_EVENT, sendExternalEvent);
    yield takeEvery(actionTypes.SOCKET_EVENT_REDIRECT_TO_URL, redirectToUrl);
    yield takeEvery(actionTypes.SOCKET_EVENT_CONTACT_INFO_GATHERED, contactInfoGathered);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/actionSaga.ts